import { DialogContainer } from '@adobe/react-spectrum';
import React, { useState } from 'react';

import { GetSupportDialog } from '@exchange-frontends/components';
import { validateEmail } from '@exchange-frontends/utils';

import HelpSupportGridListItem from './HelpSupportGridListItem';

const GetSupport = ({ label, icon, details, loading, appType }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  //In UXP user can add URL or email, so this validation is required
  if (appType?.toLowerCase() === 'cc' && validateEmail(details?.url)) {
    details.email = details.url;
    details.url = null; // only email should display instead of url
  }

  const shouldShowGetSupport = details?.email || details?.url || details?.info?.trim();

  return shouldShowGetSupport ? (
    <>
      <HelpSupportGridListItem
        icon={icon}
        label={label}
        loading={loading}
        dataLaunchId="Help and Support : Get Support"
        onClick={() => setIsDialogOpen(true)}
      />
      {isDialogOpen && (
        <DialogContainer>
          <GetSupportDialog support={details} close={() => setIsDialogOpen(false)} />
        </DialogContainer>
      )}
    </>
  ) : null;
};

export default GetSupport;
